window.Products.Bag.PremiumDrawstringBag = function () {}
window.Products.Bag.PremiumDrawstringBag.inherits(window.Products.Bag.Bag)